@for (subMod of config.mods; track subMod.id; let idx = $index) {
  @if (idx < config.maxDisplayCount) {
    <div class="keep-whitespace" [class]="config.cssClass">{{ subMod.text }}</div>
    <div>
      @if (config.showSlots && subMod.slots && subMod.slots.length > 0) {
        @for (slot of subMod.slots; track slot.id) {
          @if (slot.icon) {
            <img [src]="imgPrefix + slot.icon" class="base-type-image" [title]="slot.name" />
          } @else if (slot.exampleBaseTypeImage) {
            <img [src]="imgPrefix + slot.exampleBaseTypeImage" class="base-type-image" [title]="slot.name" />
          }
          <!-- If no known slot, just skip -->
        }
      }
      @if (config.showTags && subMod.tags && subMod.tags.length > 0) {
        @for (tag of subMod.tags; track tag.id) {
          <div class="mt" [class]="tag.color" [title]="tag.name">{{ tag.abbr }}</div>
        }
      }
    </div>
  }
}
@if (config.mods.length > config.maxDisplayCount) {
  <div [class]="config.cssClass">
    {{ config.showMoreText || '... (' + (config.mods.length - config.maxDisplayCount) + ' more)' }}
  </div>
}
